// @flow
import { generate } from 'shortid';

import * as c from './constants';

function generateIdToPayload(payload) {
  if (payload.id != null) {
    return payload;
  }

  const id = generate();

  return { ...payload, id };
}

export const confirmDialog = (payload) => ({
  type: c.CONFIRM_DIALOG,
  payload: generateIdToPayload(payload),
});

export const errorDialog = (payload) => ({
  type: c.ERROR_DIALOG,
  payload: generateIdToPayload(payload),
});

export const resolveDialog = (id: number, value: any) => ({
  type: c.RESOLVE_DIALOG,
  payload: {
    id,
    value,
  },
});



// WEBPACK FOOTER //
// ./src/common/components/dialog/actions.js